export const env = {
    production: false,
    config: {
        ohifViewerURL: ' https://nuagedx-viewer-8e027.web.app/',
        gapi: {
            clientId: '409596160399-jvos1lrt8q6lqc1u2u9fi2vokn4upe4a.apps.googleusercontent.com',
            healthcareRest: 'https://content.googleapis.com/discovery/v1/apis/healthcare/v1/rest',
            healthcareRest_v1beta1: 'https://www.googleapis.com/discovery/v1/apis/healthcare/v1beta1/rest',
            platformScope: 'https://www.googleapis.com/auth/cloud-platform',
            apiKey: 'AIzaSyCaMW--IxXHWpzH9YsM_gxMOL9tFldan5o'
        },
        allowedExtensions: {
            files: ['pdf', 'jpg', 'svg', 'png', 'jpeg', 'gif', 'doc', 'docx', 'txt'],
            video: ['vga', 'mpg', 'wbm'],
            dicom: ['dcm']
        }
    }
};
